module.exports = __webpack_public_path__ + "/assets/img/icon_create_order874fbd51.svg";